import { render } from "./ScrapingDetail.vue?vue&type=template&id=823b6e22"
import script from "./ScrapingDetail.vue?vue&type=script&lang=js"
export * from "./ScrapingDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__